<template>
  <div class="tg-card-info-item">
    <a class="content"
       :href="itemsSource.locationlink == null ? '/news/' + itemsSource.nid : itemsSource.locationlink">
      <img :src="'https://xyoss.g.com.cn/xy-production' + itemsSource.banner">
      <p>{{itemsSource.titlefull}}</p>
    </a>
  </div>
</template>

<script>
import Swiper from 'swiper';
export default {
  name: 'tg-card-info-item',
  props: {
    itemsSource: {
      type: Object,
      require: true,
    },
  },
};
</script>
